type PhoneCallProps = {
    className?: string;
    size?: number;
    fill?: string;
};

const PhoneCall = ({className, size = 20, fill = 'currentColor'}: PhoneCallProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        className={className}
        aria-hidden
    >
        <path
            d="M7.57154 6.16659C7.93259 5.8049 8.13537 5.31473 8.13537 4.80368C8.13537 4.29262 7.93259 3.80245 7.57154 3.44076L5.52654 1.39826C5.16507 1.0368 4.67481 0.83374 4.16362 0.83374C3.65243 0.83374 3.16218 1.0368 2.80071 1.39826L1.67987 2.51993C1.20829 2.99077 0.914182 3.61031 0.847497 4.27336C0.780813 4.93641 0.945656 5.60211 1.31404 6.15743C4.61479 11.1257 8.87413 15.385 13.8424 18.6858C14.3979 19.0536 15.0634 19.2183 15.7264 19.152C16.3894 19.0856 17.0091 18.7923 17.4807 18.3216L18.6015 17.1999C18.7806 17.021 18.9227 16.8085 19.0196 16.5747C19.1165 16.3408 19.1664 16.0902 19.1664 15.837C19.1664 15.5839 19.1165 15.3332 19.0196 15.0993C18.9227 14.8655 18.7806 14.653 18.6015 14.4741L16.5574 12.4299C16.3784 12.2509 16.166 12.1088 15.9321 12.0119C15.6983 11.9149 15.4476 11.8651 15.1945 11.8651C14.9413 11.8651 14.6906 11.9149 14.4568 12.0119C14.2229 12.1088 14.0105 12.2509 13.8315 12.4299L13.1499 13.1116C10.8656 11.2318 8.7691 9.13471 6.88987 6.84993L7.57154 6.16659Z"
            stroke={fill}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default PhoneCall;
